import BasicList from 'core/modules/components/lists/components/BasicList/BasicList';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';

/**
 * NotificationsList - Lista de notificaciones con scroll infinito. Envuelve el
 * genérico v2 `BasicList` (semántica `<ul>/<li>` accesible).
 */

type NotificationsListProps = Readonly<{
  getNotifications?: () => void;
  hasMoreNotifications?: boolean;
  items?: React.ReactElement[];
}>;

function NotificationsList({ getNotifications, hasMoreNotifications, items = [] }: NotificationsListProps): JSX.Element {
  return (
    <div className="notifications-list">
      <InfiniteScroll
        pageStart={0}
        loadMore={getNotifications}
        hasMore={hasMoreNotifications}
        getScrollParent={() => document.getElementById('menu-aside__content')}
        useWindow={false}
      >
        <BasicList items={items} />
      </InfiniteScroll>
    </div>
  );
}

export default NotificationsList;
